import { Component, Input, OnInit } from '@angular/core';
import { Product } from "../../../common/interfaces/Product";
// import { MerchantApi } from "../../../common/apis/merchant-api";
import { Merchant } from "../../../common/interfaces/Merchant";
import { Router } from "@angular/router";

@Component({
  selector: 'featured-dish',
  templateUrl: './featured-dish.component.html',
  styleUrls: ['./featured-dish.component.scss']
})
export class FeaturedDishComponent implements OnInit {

  @Input() product!: Product
  merchant: Merchant | null = null

  merchantImage = ""

  constructor(
    // private merchantApi: MerchantApi,
    private router: Router
  ) {
  }
  ngOnInit(): void {
    // this.merchantApi.getMerchantById(this.product.merchantId, false).subscribe({
    //   next: (merchant) => {
    //     this.merchant = merchant
    //     this.merchantImage = merchant.profilePictureURL ?? ""
    //   },
    //   error: (_) => {
    //     console.log("Failed to get merchant with id", this.product.merchantId)
    //   }
    // })
  }

  getImage() {
    if (this.product.thumbnailURL !== undefined)
      return `url("${this.product.thumbnailURL}")`
    else
      return `url(/assets/product-placeholder.svg)`
  }

  viewProduct() {
    this.router.navigate(['/product', this.product.slug]).then()
  }
}
